import styled from '@emotion/styled'
import { getFlexbox } from '@helpers/mixins'
import CircularProgress from '@mui/material/CircularProgress'

const Wrapper = styled.div`
	${getFlexbox({ flow: 'column' })}
	position: relative;
	width: 100%;
	height: 100%;
	min-height: 100px;
`

const Progress = styled(CircularProgress)``

export { Progress, Wrapper }
